(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-play-singles/assets/javascripts/single-coupon-choice.js') >= 0) return;  svs.modules.push('/components/tipsen/route-play-singles/assets/javascripts/single-coupon-choice.js');
"use strict";

const {
  useState,
  useCallback,
  useContext
} = React;
const {
  useCouponId,
  PaymentContext
} = svs.components.tipsen.couponId;
const {
  useIsCouponEmpty,
  useClearCoupon
} = svs.components.tipsen.hooks;
const {
  CouponToolbox
} = svs.components.tipsen.routePlaySpela.couponChoice;
const {
  COUPON_CHOICE_NONE,
  COUPON_CHOICE_PIX
} = svs.components.tipsen.routePlaySpela.couponChoice.constants.showCouponChoice;
const {
  SingleCouponXpert
} = svs.components.tipsen.routePlaySingles;
const {
  TipsenModal,
  StickyBottom,
  StickyButtonClose
} = svs.components.tipsen.tipsenModal;
const {
  ReactIconButton,
  ReactIcon
} = svs.ui;
const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_SM
} = svs.components.lbUtils.useMediaQuery;
const {
  ExpandableArea
} = svs.components.tipsen.expandableArea;
const {
  useActionListener
} = svs.components.tipsen.hooks;
const PixStickyBottom = _ref => {
  let {
    onActivateNone
  } = _ref;
  return React.createElement(StickyBottom, null, React.createElement(StickyButtonClose, {
    onClick: onActivateNone
  }));
};
const SingleCouponChoice = () => {
  const couponId = useCouponId();
  const placeBetAsync = useContext(PaymentContext);
  useActionListener({
    couponId,
    placeBetAsync
  });
  const [activeChoice, setActiveChoice] = useState(COUPON_CHOICE_NONE);
  const onActivateChoice = useCallback(newActiveChoice => {
    setActiveChoice(oldActiveChoice => {
      if (oldActiveChoice === newActiveChoice) {
        newActiveChoice = COUPON_CHOICE_NONE;
      }
      return newActiveChoice;
    });
  }, [setActiveChoice]);
  const isShowingPix = activeChoice === COUPON_CHOICE_PIX;
  const onActivatePix = useCallback(() => {
    onActivateChoice(COUPON_CHOICE_PIX);
  }, [onActivateChoice]);
  const onActivateNone = useCallback(() => {
    onActivateChoice(COUPON_CHOICE_NONE);
  }, [onActivateChoice]);
  const onClearCoupon = useClearCoupon(couponId);
  const isCouponEmpty = useIsCouponEmpty(couponId);
  const isExtraSmall = useMediaQuery(breakpoints.down(BREAKPOINT_SM));
  const couponToolboxGrid = document.querySelector('.coupon-toolbox');
  let arrowPosition;
  if (couponToolboxGrid) {
    const couponToolboxGridLeftPosition = couponToolboxGrid.getBoundingClientRect().left;
    if (isShowingPix) {
      const pixButton = document.querySelector('.coupon-toolbox-pix-button');
      if (pixButton) {
        const pixRect = pixButton.getBoundingClientRect();
        arrowPosition = pixRect.left + pixRect.width / 2 - couponToolboxGridLeftPosition;
      }
    }
  }
  return React.createElement(React.Fragment, null, React.createElement(CouponToolbox, {
    isCouponEmpty: isCouponEmpty,
    isShowingPix: isShowingPix,
    onActivateNone: onActivateNone,
    onActivatePix: onActivatePix,
    onClearCoupon: onClearCoupon,
    singleCouponChoice: true
  }), !isExtraSmall && React.createElement(ExpandableArea, {
    arrowPosition: arrowPosition,
    "data-testid": "expandable-area",
    isCouponMenu: true,
    isOpen: isShowingPix
  }, isShowingPix && React.createElement(React.Fragment, null, React.createElement(ReactIconButton, {
    className: "xpert-close-btn",
    onClick: onActivateNone
  }, React.createElement(ReactIcon, {
    icon: "close",
    size: "300"
  })), React.createElement(SingleCouponXpert, {
    couponId: couponId
  }))), isExtraSmall && React.createElement(TipsenModal, {
    Bottom: () => React.createElement(PixStickyBottom, {
      onActivateNone: onActivateNone
    }),
    isOpen: isShowingPix
  }, React.createElement("div", {
    className: "margin-left-1-half mobile-modal-view"
  }, React.createElement("div", {
    className: "margin-left-1-half"
  }, React.createElement("div", {
    className: "single-row-xpert-selector-header-container "
  }, React.createElement("div", {
    className: "xpert-selector-header"
  }, "Fyll i med", ' '), React.createElement(ReactIcon, {
    className: "tipsen-mobile-pix-icon",
    icon: "pix",
    size: "600"
  }))), React.createElement("p", {
    className: "margin-h-1 tipsen-mobile-pix-info-text"
  }, "PIX! erbjuder extra hj\xE4lp genom en kombination av experttips och slumpen.")), React.createElement(SingleCouponXpert, {
    couponId: couponId
  })));
};
setGlobal('svs.components.tipsen.routePlaySingles.SingleCouponChoice', SingleCouponChoice);

 })(window);